import { BOLD, GLOBAL_VARS, ITALIC } from '../editorCapabilities/constants';
import { EditorConfig } from '../editorCapabilities/editorCapabilitiesTypes';
import { PlaintextOptions } from './plaintextUtils';

/** Configuration for global editor variables (default styling and behavior) */
export type GlobalVarsOptions = {
  /** Default font size for new text (CSS value, e.g., '14px') */
  defaultFontSize?: string;
  /** Default font family for new text (CSS font-family value) */
  defaultFontStyle?: string;
  /** Default text color for new text (CSS color value) */
  defaultTextColor?: string;
  /** When true, uses the compact inbox-style layout */
  useInboxLayout?: boolean;
  /** When true, shows insert options in a dropdown menu instead of individual buttons */
  useInsertMenu?: boolean;
  /** When true, disables rich text formatting and uses plain text mode */
  usePlaintextMode?: boolean;
};

const getPlaintextOptions = (
  editorConfig: Partial<EditorConfig>
): PlaintextOptions => {
  const hasBasicFormatting = editorConfig[BOLD] || editorConfig[ITALIC];
  if (
    editorConfig[GLOBAL_VARS] &&
    editorConfig[GLOBAL_VARS].usePlaintextMode &&
    hasBasicFormatting
  ) {
    return {
      allowBasicFormatting: true,
    };
  }
  return {};
};

export const getGlobalVars = (editorConfig: Partial<EditorConfig>) => {
  return {
    ...editorConfig[GLOBAL_VARS],
    plaintextOptions: getPlaintextOptions(editorConfig),
  };
};
